import { useContext } from 'react';

import {
	getSingleParam,
	getSingleParamInt,
} from '@confluence/route-manager-utils/entry-points/getSingleParam.ts';
// eslint-disable-next-line no-restricted-imports -- deprecated - use RouteState instead
import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext.ts';

type ViewPageParams = {
	versionOverride: null | number;
	embeddedContentRender: null | string;
	isBridgeContentReuseEligible: boolean;
	queryHash?: string;
};

export function useViewPageParams(): ViewPageParams {
	const { getQueryParams, getHash } = useContext(RoutesContext);
	const queryParams = getQueryParams();

	// Setting versionOverride and embeddedContentRender to null
	// if they don't have valid value
	const versionOverride: number | null = getSingleParamInt(queryParams, 'versionOverride', null);

	const embeddedContentRender = getSingleParam(queryParams, 'embeddedContentRender') || null;

	// Hash is being used in content body
	const queryHash = getHash();
	return {
		versionOverride,
		embeddedContentRender,
		isBridgeContentReuseEligible: !(
			queryParams.versionOverride ||
			queryParams.lite ||
			queryParams.draftShareId ||
			queryParams.embedded ||
			queryParams.parentProduct
		),
		queryHash,
	};
}
